import React, { useState } from 'react'
import Button from '@SiteComponents/Button'

import './VoiceTypeUpgradePopup.scss'

interface VoiceTypeUpgradePopupProps {
  readonly canManageSubscription: boolean
  readonly tooltipDelay: number
  readonly voiceType: string
  onUpgrade?(): void
  onReturn?(): void
}

const VoiceTypeUpgradePopup: React.FC<VoiceTypeUpgradePopupProps> = props => {
  const shouldDisableUpgradeButton = !props.canManageSubscription
  const [showInfo, setShowInfo] = useState(false)
  const [infoTimeout, setInfoTimeout] = useState<ReturnType<typeof setTimeout> | null>(null)
  const shouldShowInfo = showInfo && shouldDisableUpgradeButton

  const handleUpgrade = () => {
    if (props.onUpgrade) {
      props.onUpgrade()
    }
  }

  const handleReturn = () => {
    if (props.onReturn) {
      props.onReturn()
    }
  }

  const displayInfo = () => {
    if (infoTimeout) { return }

    const newInfoTimeout = setTimeout(() => {
      setShowInfo(true)
    }, props.tooltipDelay)
    setInfoTimeout(newInfoTimeout)
  }

  const hideInfo = () => {
    if (!infoTimeout) { return }

    setShowInfo(false)
    clearTimeout(infoTimeout)
    setInfoTimeout(null)
  }

  const renderInfo = () => {
    return (
      <div className="VoiceTypeUpgradePopup__info-disabled">
        Contact your account admin or the Checksub support to upgrade
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="VoiceTypeUpgradePopup__title">
        {props.voiceType} selected!
      </div>
      <div className="VoiceTypeUpgradePopup__description">
        Great choice! This powerful feature requires a paid Starter plan to unlock the full potential of personalized voice generation.
      </div>
      <div className="VoiceTypeUpgradePopup__buttons">
        <div
          className="VoiceTypeUpgradePopup__button-wrapper"
          onMouseEnter={displayInfo}
          onMouseLeave={hideInfo}
        >
          <Button
            caption="View plans & Upgrade"
            onClick={handleUpgrade}
            styleType="brand"
            size="large"
            disabled={shouldDisableUpgradeButton}
          />
        </div>
        <Button
          caption="Choose different option"
          onClick={handleReturn}
          styleType="gray-subtle"
          size="large"
        />
        {shouldShowInfo && renderInfo()}
      </div>
    </React.Fragment>
  )
}

export default VoiceTypeUpgradePopup
